import { IAgreement } from 'models/agreements';

export const canSignAgreement = (agreement: IAgreement, personalIdentificationCode?: string | null): boolean => {
    const signers = agreement.signers;
    if (!signers || !signers.length) return true;

    if (!personalIdentificationCode) return false;

    const signer = signers.find(s => s.idCode === personalIdentificationCode);

    return !!signer && !signer.isSigned;
};

export const GENERIC_SIGNING_ERROR = 'Ilmnes viga allkirjastamisel';

const SIGNER_MISMATCH_SERVER_MESSAGE = 'The signer must be the currently logged in user';

export const getSigningErrorMessage = (error: any): string => {
    const message = error?.message;

    if (typeof message === 'string' && message.includes(SIGNER_MISMATCH_SERVER_MESSAGE)) {
        return 'Kontrolli, et sisestatud isikukood oleks sinu oma.';
    }

    return GENERIC_SIGNING_ERROR;
};
